import BuyService from './BuyService';

export default BuyService;
